const STATES = [
  { state_id: "CA", state_name: "California" },
  { state_id: "Non-U.S.", state_name: "Non-U.S." },
  { state_id: "AL", state_name: "Alabama" },
  { state_id: "AK", state_name: "Alaska" },
  { state_id: "AS", state_name: "American Samoa" },
  { state_id: "AZ", state_name: "Arizona" },
  { state_id: "AR", state_name: "Arkansas" },
  { state_id: "CO", state_name: "Colorado" },
  { state_id: "CT", state_name: "Connecticut" },
  { state_id: "DE", state_name: "Delaware" },
  { state_id: "DC", state_name: "District of Columbia" },
  { state_id: "FL", state_name: "Florida" },
  { state_id: "GA", state_name: "Georgia" },
  { state_id: "GU", state_name: "Guam" },
  { state_id: "HI", state_name: "Hawaii" },
  { state_id: "ID", state_name: "Idaho" },
  { state_id: "IL", state_name: "Illinois" },
  { state_id: "IN", state_name: "Indiana" },
  { state_id: "IA", state_name: "Iowa" },
  { state_id: "KS", state_name: "Kansas" },
  { state_id: "KY", state_name: "Kentucky" },
  { state_id: "LA", state_name: "Louisiana" },
  { state_id: "ME", state_name: "Maine" },
  { state_id: "MD", state_name: "Maryland" },
  { state_id: "MA", state_name: "Massachusetts" },
  { state_id: "MI", state_name: "Michigan" },
  { state_id: "MN", state_name: "Minnesota" },
  { state_id: "MS", state_name: "Mississippi" },
  { state_id: "MO", state_name: "Missouri" },
  { state_id: "MT", state_name: "Montana" },
  { state_id: "NE", state_name: "Nebraska" },
  { state_id: "NV", state_name: "Nevada" },
  { state_id: "NH", state_name: "New Hampshire" },
  { state_id: "NJ", state_name: "New Jersey" },
  { state_id: "NM", state_name: "New Mexico" },
  { state_id: "NY", state_name: "New York" },
  { state_id: "NC", state_name: "North Carolina" },
  { state_id: "ND", state_name: "North Dakota" },
  { state_id: "MP", state_name: "Northern Mariana Islands" },
  { state_id: "OH", state_name: "Ohio" },
  { state_id: "OK", state_name: "Oklahoma" },
  { state_id: "OR", state_name: "Oregon" },
  { state_id: "PA", state_name: "Pennsylvania" },
  { state_id: "PR", state_name: "Puerto Rico" },
  { state_id: "RI", state_name: "Rhode Island" },
  { state_id: "SC", state_name: "South Carolina" },
  { state_id: "SD", state_name: "South Dakota" },
  { state_id: "TN", state_name: "Tennessee" },
  { state_id: "TX", state_name: "Texas" },
  { state_id: "UT", state_name: "Utah" },
  { state_id: "VT", state_name: "Vermont" },
  { state_id: "VA", state_name: "Virginia" },
  { state_id: "VI", state_name: "Virgin Islands" },
  { state_id: "WA", state_name: "Washington" },
  { state_id: "WV", state_name: "West Virginia" },
  { state_id: "WI", state_name: "Wisconsin" },
  { state_id: "WY", state_name: "Wyoming" }
];

export const stateOptions = () => {
  return [
    { value: '', label: 'Select State' },
    ...STATES.map(state => ({
      value: state.state_id,
      label: state.state_name
    }))
  ]
}

export const gradeOptions = () => ([
  { value: '', label: 'Select Grade' }, // 默认空选项
  { value: 'K', label: 'Kindergarten' },
  { value: '1', label: '1st Grade' },
  { value: '2', label: '2nd Grade' },
  { value: '3', label: '3rd Grade' },
  { value: '4', label: '4th Grade' },
  { value: '5', label: '5th Grade' },
  { value: '6', label: '6th Grade' },
  { value: '7', label: '7th Grade' },
  { value: '8', label: '8th Grade' },
  { value: '9', label: '9th Grade' },
  { value: '10', label: '10th Grade' },
  { value: '11', label: '11th Grade' },
  { value: '12', label: '12th Grade' },
]);

  // 生成出生年份选项 (最近20年)
export const birthYearOptions = () => {
  const currentYear = new Date().getFullYear();
  const years = [{ value: '', label: 'Select Birth Year' }]; // 添加默认空选项
  for (let i = currentYear; i >= currentYear - 20; i--) {
    years.push({ value: String(i), label: String(i) });
  }
  return years;
};

export const roleOptions = () => ([
  { value: '', label: 'I am a...' },
  { value: 'student', label: 'Student' },
  { value: 'parent', label: 'Parent' },
  { value: 'teacher', label: 'Teacher' },
]);

export const voiceOptions = () => [
  // grade 3、4
  { id: 1, label: 'Playful Pixie', voiceId: 'Cute_Elf' },
  // grade 5、6
  { id: 2, label: 'Lively Lily', voiceId: 'English_PlayfulGirl' },
  // grade 7、8
  { id: 3, label: 'Jolly Rudy', voiceId: 'moss_audio_7c7e7ae2-7356-11f0-9540-7ef9b4b62566' },
  { id: 4, label: 'Chill Jeff', voiceId: 'English_Kind-heartedGirl' },
  { id: 5, label: 'Cheery Max', voiceId: 'Rudolph' },
  { id: 6, label: 'Calm Theo', voiceId: 'English_Gentle-voiced_man' },
];
